import classNames from "classnames";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";

import { Icon } from "src/app/components/icon/Icon";
import { ROLE, ROUTES } from "src/config/constants";
import { AccountResponse } from "src/core/models/auth";
import { ProjectResponse } from "src/core/models/projects";

import actionsCSS from "./Actions.module.css";

const MobileActions = ({
  user,
  project,
  isAdminLocation,
  handleDelete,
  openProjectRename,
  openPartnerModal,
  downloadProject,
  downloadSystemProjectPdf,
  downloadSystemProjectExcel,
  sendToMail,
  setRef,
}: {
  user: AccountResponse | undefined;
  project: ProjectResponse | undefined;
  isAdminLocation: boolean;
  handleDelete: (project: ProjectResponse | undefined) => void;
  openProjectRename: (projectId: number | undefined) => void;
  openPartnerModal: (project: ProjectResponse | undefined) => void;
  downloadProject: (projectId: number | undefined, projectName: string) => void;
  downloadSystemProjectPdf: (projectId: number | undefined, projectName: string) => void;
  downloadSystemProjectExcel: (projectId: number | undefined, projectName: string) => void;
  sendToMail: (projectId: number | undefined) => void;
  setRef: (key: number, refElem: any) => void;
}) => {
  let history = useHistory();

  function duplicateProject() {
    const duplicateLink = `${ROUTES.home}?upitBroj=${project?.id}`;
    history.push(duplicateLink);
  }

  return (
    <div className={classNames("u-block", "u-pos-fixed", "u-z-index10", "u-w100", "u-h100 ", "u-bg-black", "u-bg-black-light", actionsCSS.mobileActionCont)}>
      <div ref={(refElem) => setRef(0, refElem)} className={classNames("u-h8", actionsCSS.mobileAction)}>
        <div className={actionsCSS.rectangleH}></div>
        <div className="u-flex u-flex-content-center u-mt10px u-pb10px u-mb20px u-borderSecLight u-w100">
          <h6 className="u-t-f16p u-t-lh15 u-t-secondary u-t-w400 u-t-uppercase u-m0">Opcije</h6>
        </div>
        <div className={classNames("u-flex", "u-col-12", "u-flex-items-center", "u-flex-column", actionsCSS.optionsCont)}>
          <div className="u-mb20px">
            <Link
              to={isAdminLocation ? ROUTES.showAdminUserProject(project?.userId, project?.id) : ROUTES.showUserProject(project?.userId, project?.id)}
              className="u-t-valign-mid u-font-family-inh u-t-f16p u-t-lh15 u-t-black u-t-nodecoration u-t-w400 u-cursor-pointer"
            >
              Otvori
            </Link>
          </div>
          {isAdminLocation && (
            <div className="u-mb20px">
              <Link
                to={ROUTES.showAdminUserProjects(project?.userId)}
                className="u-t-valign-mid u-font-family-inh u-t-f16p u-t-lh15 u-t-black u-t-nodecoration u-t-w400 u-cursor-pointer"
              >
                Svi izračuni korisnika
              </Link>
            </div>
          )}
          {!isAdminLocation && (
            <div className="u-flex u-col-12 u-flex-items-center u-flex-column">
              <div onClick={() => openProjectRename(project?.id)} className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer">
                Preimenuj
              </div>
              <div onClick={() => duplicateProject()} className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer">
                Dupliciraj
              </div>
              {(user?.role === ROLE.Admin || user?.role === ROLE.RegionalAdmin) && !project?.partnerName && (
                <div onClick={() => openPartnerModal(project!)} className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer">
                  Pošalji partneru
                </div>
              )}
              {(user?.role === ROLE.Admin || user?.role === ROLE.RegionalAdmin) && (
                <div onClick={() => sendToMail(project?.id)} className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer">
                  Pošalji na mail
                </div>
              )}
              {(user?.role === ROLE.Admin || user?.role === ROLE.RegionalAdmin) && (
                <div
                  onClick={() => downloadProject(project?.id, project?.name!)}
                  className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer"
                >
                  Preuzmi
                </div>
              )}
              {(user?.role === ROLE.Admin || user?.role === ROLE.RegionalAdmin) && (
                <div
                  onClick={() => downloadSystemProjectPdf(project?.id, project?.name!)}
                  className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer"
                >
                  Preuzmi po sustavu PDF
                </div>
              )}
              {(user?.role === ROLE.Admin || user?.role === ROLE.RegionalAdmin) && (
                <div
                  onClick={() => downloadSystemProjectExcel(project?.id, project?.name!)}
                  className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer"
                >
                  Preuzmi po sustavu xlsx
                </div>
              )}
              <div onClick={() => handleDelete(project)} className="u-font-family-inh u-t-black u-mb20px u-t-f16p u-t-lh15 u-cursor-pointer">
                <Icon name="trash" className="u-t-error u-t-f13p"></Icon>
                <span className="u-ml10px">Izbriši</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileActions;
